(function () {
  var root = document.querySelector("[data-promo-corner-popup]");
  if (!root) return;

  var closeBtn = root.querySelector("[data-promo-corner-popup-close]");
  var delayMs = parseInt(root.getAttribute("data-delay-ms") || "4000", 10);
  var storageKey = root.getAttribute("data-storage-key");
  var designMode = root.getAttribute("data-design-mode") === "true";

  function hideFromDom() {
    root.hidden = true;
    root.setAttribute("aria-hidden", "true");
  }

  function show() {
    root.hidden = false;
    root.setAttribute("aria-hidden", "false");
    requestAnimationFrame(function () {
      root.classList.add("is-visible");
    });
  }

  var finishedDismiss = false;

  function dismiss() {
    if (finishedDismiss) return;
    if (root.classList.contains("is-leaving")) return;
    root.classList.remove("is-visible");
    root.classList.add("is-leaving");
    function onEnd(e) {
      if (e.propertyName !== "opacity" && e.propertyName !== "transform") return;
      finishDismiss();
    }
    function finishDismiss() {
      if (finishedDismiss) return;
      finishedDismiss = true;
      root.removeEventListener("transitionend", onEnd);
      hideFromDom();
      root.classList.remove("is-leaving");
      if (!designMode && storageKey) {
        try {
          localStorage.setItem(storageKey, "1");
        } catch (_) {}
      }
    }
    root.addEventListener("transitionend", onEnd);
    window.setTimeout(finishDismiss, 450);
  }

  if (!designMode && storageKey) {
    try {
      if (localStorage.getItem(storageKey) === "1") {
        hideFromDom();
        return;
      }
    } catch (_) {}
  }

  window.setTimeout(show, Math.max(0, delayMs));

  if (closeBtn) {
    closeBtn.addEventListener("click", dismiss);
  }

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (root.hidden || !root.classList.contains("is-visible")) return;
    dismiss();
  });
})();
